import React from 'react';

export default function LoadingSpinner({ fullPage = false, size = 'md', text = '' }) {
    const sizes = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12' };
    const spinner = (
        <div className="flex flex-col items-center gap-3">
            <div className={`${sizes[size]} border-4 border-gray-200 border-t-accent rounded-full animate-spin`}
                style={{ borderTopColor: '#e94560' }}></div>
            {text && <p className="text-gray-500 text-sm">{text}</p>}
        </div>
    );
    if (fullPage) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                {spinner}
            </div>
        );
    }
    return spinner;
}
